import React, { useState, useEffect } from 'react';
import UploadForm from './components/UploadForm';
import { FiMoon, FiSun } from 'react-icons/fi';

export default function App() {
  const [dark, setDark] = useState(false);

  // Toggle the `dark` class on <html>
  useEffect(() => {
    if (dark) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [dark]);

  return (
    <div className="min-h-screen flex flex-col justify-between
                    bg-gradient-to-br from-white via-blue-50 to-blue-100
                    dark:from-gray-900 dark:via-gray-800 dark:to-gray-700
                    transition-colors">
      {/* Header + Hero */}
      <header className="relative px-4 py-8 text-center">
        <button
          onClick={() => setDark(d => !d)}
          className="absolute top-4 right-4 p-2 rounded-full bg-white/60
                     dark:bg-gray-800/60 hover:bg-white/80 dark:hover:bg-gray-800/80 transition"
        >
          {dark ? <FiSun className="text-yellow-400"/> : <FiMoon className="text-gray-700"/>}
        </button>
        <h1 className="text-5xl font-extrabold text-blue-600 dark:text-blue-400">
          IntelliCaller
        </h1>
        <p className="mt-2 text-gray-600 dark:text-gray-300">
          Upload a call recording. Get instant AI feedback.
        </p>
      </header>

      {/* Main Content */}
      <main className="flex-grow flex items-center justify-center px-4">
        <div className="w-full max-w-xl">
          <UploadForm />
        </div>
      </main>

      {/* Footer */}
      <footer className="px-4 py-4 text-center text-sm text-gray-500 dark:text-gray-400">
        © {new Date().getFullYear()} IntelliCaller — AI-powered call insights
      </footer>
    </div>
  );
}
